module.exports = __webpack_public_path__ + "static/media/Eaton-Estates.aa021ac7.pdf";